import React, { useMemo } from 'react'
import './StatusBadge.css'

export enum StatusTypes {
  Active = 'Active',
  Alert = 'Alert',
  Allergies = 'Allergies',
  Alerts = 'Alerts',
  Appointments = 'Appointments',
  Archived = 'Archived',
  Cancelled = 'Cancelled',
  CheckIn = 'Check-in',
  CheckOut = 'Check-out',
  Conditions = 'Conditions',
  Completed = 'Completed',
  Images = 'Images',
  Confirmed = 'Confirmed',
  Deceased = 'Deceased',
  Deleted = 'Deleted',
  Draft = 'Draft',
  FollowUp = 'Follow-up',
  FullTime = 'Full-Time',
  Inactive = 'Inactive',
  Incomplete = 'Incomplete',
  InTreatment = 'In-Treatment',
  InvoiceSent = 'Invoice Sent',
  Late = 'Late',
  Marketing = 'Marketing',
  NewPatient = 'New Patient',
  NonPatient = 'Non-patient',
  NoShow = 'No Show',
  PartTime = 'Part-Time',
  Paid = 'Paid',
  PaymentPending = 'Payment Pending',
  Payments = 'Payments',
  Patient = 'Patient',
  PatientLate = 'Patient Late',
  Pending = 'Pending',
  Prospective = 'Prospective',
  RevisionNeeded = 'Revision Needed',
  Records = 'Records',
  Scheduled = 'Scheduled',
  Unpaid = 'Unpaid',
  PartiallyPaid = 'Partially paid',
  Proposed = 'Proposed',
  Accepted = 'Accepted',
  Complete = 'Complete',
  Approved = 'Approved',
  Denied = 'Denied',
  Rejected = 'Rejected',
  UnderReview = 'Under Review',
  PartiallyApproved = 'Partially Approved',
  Unclaimed = 'Unclaimed',
  Claimed = 'Claimed',
  Billed = 'Billed',
  Unbilled = 'Unbilled',
  New = 'New',
  Processing = 'Processing',
  Cleared = 'Cleared',
  Deposited = 'Deposited',
  Posted = 'Posted',
  TxReview = 'Tx.Review',
  Preparing = 'Preparing',
  OutForDelivery = 'Out For Delivery',
  Unconfirmed = 'Unconfirmed',
  Forwarded = 'Forwarded',
  HalfDay = 'Half-day',
  OnLeave = 'On-leave',
  Primary = 'Primary',
  Billing = 'Billing',
  Claim = 'Claim',
  Procedure = 'Procedure',
  Verified = 'Verified',
  NA = 'N/A',
  Rescheduled = 'Rescheduled',
}

export const STATUS_STYLES: Record<StatusTypes, React.CSSProperties> = {
  [StatusTypes.Active]: {
    backgroundColor: 'var(--vivid-green-200)',
    color: 'var(--vivid-green-700)',
  },
  [StatusTypes.Alert]: {
    backgroundColor: 'var(--red-200)',
    color: 'var(--red-600)',
  },
  [StatusTypes.Allergies]: {
    backgroundColor: '#D4C6DE',
    color: '#32233E',
  },
  [StatusTypes.Alerts]: {
    backgroundColor: '#FFCBC8',
    color: '#9E1F16',
  },
  [StatusTypes.Appointments]: {
    backgroundColor: '#185DD8',
    color: '#ffffff',
  },
  [StatusTypes.Archived]: {
    backgroundColor: '#9E1F16',
    color: '#FFF',
  },
  [StatusTypes.Cancelled]: {
    backgroundColor: '#FFF2F1',
    color: '#9E1F16',
  },
  [StatusTypes.Conditions]: {
    backgroundColor: '#F0D980',
    color: '#5E4B03',
  },
  [StatusTypes.Completed]: {
    backgroundColor: '#F0F7FE',
    color: '#112850',
  },
  [StatusTypes.Images]: {
    backgroundColor: '#F0F7FE',
    color: '#112850',
  },
  [StatusTypes.Confirmed]: {
    backgroundColor: '#CBEBD3',
    color: '#14341F',
  },
  [StatusTypes.Deceased]: {
    backgroundColor: '#F5C6A4',
    color: '#542808',
  },
  [StatusTypes.Deleted]: {
    backgroundColor: '#F5C6A4',
    color: '#542808',
  },
  [StatusTypes.Draft]: {
    backgroundColor: 'var(--gray-200)',
    color: 'var(--gray-white)',
  },
  [StatusTypes.FollowUp]: {
    backgroundColor: '#B1D5FB',
    color: '#112850',
  },
  [StatusTypes.FullTime]: {
    backgroundColor: '#B1DDBB',
    color: '#14341F',
  },
  [StatusTypes.Inactive]: {
    backgroundColor: '#F5C6A4',
    color: '#542808',
  },
  [StatusTypes.Incomplete]: {
    backgroundColor: '#F5C6A4',
    color: '#542808',
  },
  [StatusTypes.InvoiceSent]: {
    backgroundColor: '#ACDAD7',
    color: '#11413F',
  },
  [StatusTypes.Late]: {
    backgroundColor: '#FFCBC8',
    color: '#9E1F16',
  },
  [StatusTypes.Marketing]: {
    backgroundColor: '#C5D6FF',
    color: '#322CA7',
  },
  [StatusTypes.NewPatient]: {
    backgroundColor: '#C6F0ED',
    color: '#133539',
  },
  [StatusTypes.NoShow]: {
    backgroundColor: '#EDCA31',
    color: '#3D2F0B',
  },
  [StatusTypes.NonPatient]: {
    backgroundColor: '#C6F0ED',
    color: '#133539',
  },
  [StatusTypes.PartTime]: {
    backgroundColor: '#F5C6A4',
    color: '#542808',
  },
  [StatusTypes.Paid]: {
    backgroundColor: '#cbebd3',
    color: '#14341f',
  },
  [StatusTypes.Patient]: {
    backgroundColor: '#E0E0E0',
    color: '#1b1d22',
  },
  [StatusTypes.PaymentPending]: {
    backgroundColor: '#813C0B',
    color: '#ffffff',
  },
  [StatusTypes.Payments]: {
    backgroundColor: '#3E8E53',
    color: '#ffffff',
  },
  [StatusTypes.PatientLate]: {
    backgroundColor: '#7A1D17',
    color: '#ffffff',
  },
  [StatusTypes.Pending]: {
    backgroundColor: 'var(--gray-100)',
    color: 'var(--gray-600)',
  },
  [StatusTypes.Prospective]: {
    backgroundColor: '#C5D6FF',
    color: '#322CA7',
  },
  [StatusTypes.RevisionNeeded]: {
    backgroundColor: '#F0D980',
    color: '#5E4B03',
  },
  [StatusTypes.Records]: {
    backgroundColor: '#C6F0ED',
    color: '#133539',
  },
  [StatusTypes.Scheduled]: {
    backgroundColor: '#B1DDBB',
    color: '#114A19',
  },
  [StatusTypes.Unpaid]: {
    backgroundColor: '#F4BBB6',
    color: '#43120F',
  },
  [StatusTypes.PartiallyPaid]: {
    backgroundColor: '#F7F1B6',
    color: '#7B6718',
  },
  [StatusTypes.Proposed]: {
    backgroundColor: '#C6F0ED',
    color: '#133539',
  },
  [StatusTypes.Accepted]: {
    backgroundColor: '#5D9310',
    color: '#FFFFFF',
  },
  [StatusTypes.Complete]: {
    backgroundColor: '#CBEBD3',
    color: '#14341FF',
  },
  [StatusTypes.Approved]: {
    backgroundColor: 'var(--vivid-green-200)',
    color: 'var(--vivid-green-700)',
  },
  [StatusTypes.Denied]: {
    backgroundColor: '#FFF2F1',
    color: '#9E1F16',
  },
  [StatusTypes.Rejected]: {
    backgroundColor: '#FFF2F1',
    color: '#9E1F16',
  },
  [StatusTypes.UnderReview]: {
    backgroundColor: '#EDCA31',
    color: '#3D2F0B',
  },
  [StatusTypes.PartiallyApproved]: {
    backgroundColor: '#E4F0D0',
    color: '#19250E',
  },
  [StatusTypes.Unclaimed]: {
    backgroundColor: '#FFCBC8',
    color: '#9E1F16',
  },
  [StatusTypes.Claimed]: {
    backgroundColor: '#275433',
    color: '#ffffff',
  },
  [StatusTypes.Billed]: {
    backgroundColor: '#CBEBD3',
    color: '#145D2B',
  },
  [StatusTypes.Unbilled]: {
    backgroundColor: '#F4BBB6',
    color: '#9E1F16',
  },
  [StatusTypes.New]: {
    backgroundColor: '#B1D5FB',
    color: '#112850',
  },
  [StatusTypes.Processing]: {
    backgroundColor: '#C6F0ED',
    color: '#133539',
  },
  [StatusTypes.Cleared]: {
    backgroundColor: '#CBEBD3',
    color: '#14341F',
  },
  [StatusTypes.Deposited]: {
    backgroundColor: '#F5C6A4',
    color: '#3C1E0C',
  },
  [StatusTypes.Posted]: {
    backgroundColor: '#5D9310',
    color: '#FFFFFF',
  },
  [StatusTypes.TxReview]: {
    backgroundColor: '#FFF089',
    color: '#3D2F0B',
  },
  [StatusTypes.Preparing]: {
    backgroundColor: '#C6F0ED',
    color: '#133539',
  },
  [StatusTypes.OutForDelivery]: {
    backgroundColor: '#C5D6FF',
    color: '#03063A',
  },
  [StatusTypes.CheckIn]: {
    backgroundColor: '#CBEBD3',
    color: '#14341F',
  },
  [StatusTypes.CheckOut]: {
    backgroundColor: '#1F565C',
    color: '#FFFFFF',
  },
  [StatusTypes.InTreatment]: {
    backgroundColor: '#163DA2',
    color: '#FFFFFF',
  },
  [StatusTypes.Unconfirmed]: {
    backgroundColor: '#7B6718',
    color: '#FFF',
  },
  [StatusTypes.Forwarded]: {
    backgroundColor: '#EDCA31',
    color: '#3D2F0B',
  },
  [StatusTypes.HalfDay]: {
    backgroundColor: 'var(--teal-200)',
    color: 'var(--teal-700)',
  },
  [StatusTypes.OnLeave]: {
    backgroundColor: 'var(--indigo-200)',
    color: 'var(--indigo-700)',
  },
  [StatusTypes.Primary]: {
    backgroundColor: 'var(--teal-200)',
    color: 'var(--teal-700)',
  },
  [StatusTypes.Billing]: {
    backgroundColor: 'var(--teal-200)',
    color: 'var(--teal-700)',
  },
  [StatusTypes.Claim]: {
    backgroundColor: 'var(--orange-200)',
    color: 'var(--orange-700)',
  },
  [StatusTypes.Procedure]: {
    backgroundColor: 'var(--blue-100)',
    color: 'var(--blue-700)',
  },
  [StatusTypes.Verified]: {
    backgroundColor: 'var(--vivid-green-200)',
    color: 'var(--vivid-green-700)',
  },
  [StatusTypes.NA]: {
    backgroundColor: 'var(--gray-100)',
    color: 'var(--gray-600)',
  },
  [StatusTypes.Rescheduled]: {
    backgroundColor: 'var(--teal-200)',
    color: 'var(--teal-700)',
  },
}

export const CLAIMS_STATUS_STYLES: Record<
  | StatusTypes.Approved
  | StatusTypes.Rejected
  | StatusTypes.UnderReview
  | StatusTypes.Draft,
  React.CSSProperties
> = {
  [StatusTypes.Approved]: {
    backgroundColor: 'var(--vivid-green-200)',
    color: 'var(--vivid-green-700)',
  },
  [StatusTypes.Rejected]: {
    backgroundColor: 'var(--red-100)',
    color: 'var(--red-600)',
  },
  [StatusTypes.UnderReview]: {
    backgroundColor: 'var(--yellow-300)',
    color: 'var(--gray-700)',
  },
  [StatusTypes.Draft]: {
    backgroundColor: 'var(--blue-100)',
    color: 'var(--blue-700)',
  },
}

export const TRACKING_STATUS_STYLES: Record<
  | StatusTypes.Pending
  | StatusTypes.Processing
  | StatusTypes.Cleared
  | StatusTypes.Deposited
  | StatusTypes.Posted,
  React.CSSProperties
> = {
  [StatusTypes.Pending]: {
    backgroundColor: 'var(--yellow-300)',
    color: 'var(--gray-700)',
  },
  [StatusTypes.Processing]: {
    backgroundColor: 'var(--blue-100)',
    color: 'var(--blue-700)',
  },
  [StatusTypes.Cleared]: {
    backgroundColor: 'var(--vivid-green-200)',
    color: 'var(--vivid-green-700)',
  },
  [StatusTypes.Deposited]: {
    backgroundColor: '#F5C6A4',
    color: '#3C1E0C',
  },
  [StatusTypes.Posted]: {
    backgroundColor: '#5D9310',
    color: '#FFFFFF',
  },
}

interface StatusBadgeProps {
  status: StatusTypes
  type?: 'claims' | 'tracking' | 'default'
}

const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  type = 'default',
}) => {
  const badgeStyle = useMemo(() => {
    if (
      type === 'claims' &&
      [
        StatusTypes.Approved,
        StatusTypes.Rejected,
        StatusTypes.UnderReview,
        StatusTypes.Draft,
      ].includes(status)
    ) {
      return CLAIMS_STATUS_STYLES[
        status as
          | StatusTypes.Approved
          | StatusTypes.Rejected
          | StatusTypes.UnderReview
          | StatusTypes.Draft
      ]
    }
    if (
      type === 'tracking' &&
      [
        StatusTypes.Pending,
        StatusTypes.Processing,
        StatusTypes.Cleared,
        StatusTypes.Deposited,
        StatusTypes.Posted,
      ].includes(status)
    ) {
      return TRACKING_STATUS_STYLES[
        status as
          | StatusTypes.Pending
          | StatusTypes.Processing
          | StatusTypes.Cleared
          | StatusTypes.Deposited
          | StatusTypes.Posted
      ]
    }
    return (
      STATUS_STYLES[status] || {
        backgroundColor: '#E0E0E0',
        color: '#ffffff',
      }
    )
  }, [status, type])

  return (
    <span className="badge-status" style={badgeStyle} data-status={status}>
      {status}
    </span>
  )
}

export default StatusBadge
